var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_8969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_8969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6966 12C7.48478 12 6.44738 11.5594 5.58441 10.6781C4.72145 9.79688 4.28996 8.7375 4.28996 7.5C4.28996 6.2625 4.72145 5.20312 5.58441 4.32188C6.44738 3.44063 7.48478 3 8.6966 3C9.90843 3 10.9458 3.44063 11.8088 4.32188C12.6718 5.20312 13.1032 6.2625 13.1032 7.5C13.1032 8.7375 12.6718 9.79688 11.8088 10.6781C10.9458 11.5594 9.90843 12 8.6966 12ZM19.7132 7.5C19.7132 8.7375 19.2817 9.79688 18.4188 10.6781C17.5558 11.5594 16.5184 12 15.3066 12C15.1046 12 14.8475 11.9766 14.5354 11.9297C14.2233 11.8828 13.9662 11.8313 13.7642 11.775C14.26 11.175 14.641 10.5094 14.9072 9.77813C15.1734 9.04688 15.3066 8.2875 15.3066 7.5C15.3066 6.7125 15.1734 5.95312 14.9072 5.22187C14.641 4.49063 14.26 3.825 13.7642 3.225C14.0213 3.13125 14.2783 3.07031 14.5354 3.04219C14.7925 3.01406 15.0495 3 15.3066 3C16.5184 3 17.5558 3.44063 18.4188 4.32188C19.2817 5.20312 19.7132 6.2625 19.7132 7.5Z",
    fill: "#182A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.984985 19.8755C0.984985 16.1463 3.92848 13.125 7.56175 13.125H10.9331C14.5664 13.125 17.5099 16.1463 17.5099 19.8755C17.5099 20.4965 17.0193 21 16.4144 21H2.0805C1.47557 21 0.984985 20.4965 0.984985 19.8755Z",
    fill: "#182A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8895 21C22.4944 21 22.985 20.4965 22.985 19.8755C22.985 16.1463 20.0415 13.125 16.4082 13.125H13.6541C17.2873 13.125 20.8087 16.1463 20.8087 19.8755C20.8087 20.4965 20.3181 21 19.7132 21H21.8895Z",
    fill: "#182A52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.89df0c58d4b46093f1aeac5376ff1ee4.svg";
export { ForwardRef as ReactComponent };